import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE3_2 = () => (
  <Section>

    <P gapAfter>
      oder gemeinsam auf dem Whiteboard und halten Sie die Durchschnittswerte der Schätzungen an der Tafel/am Whiteboard fest:
    </P>

    <UL disc>
      <LI>Kleidungskauf: Wie viele Kleidungsstücke werden von 1 Person in Deutschland durchschnittlich im Jahr gekauft?&nbsp;<em>(Lösung: 60)</em></LI>
      <LI>Wie viele unserer Klamotten sind aus Plastik hergestellt?&nbsp;<em>(Lösung: 70 Prozent)</em></LI>
      <LI>Wie viele Liter Wasser werden verbraucht, um ein Baumwoll-Shirt herzustellen?&nbsp;<em>(Lösung: 15.000 Liter)</em></LI>
      <LI>Wie viele Kilometer reisen die Shirts nach Deutschland?&nbsp;<em>(Lösung: 20.000 km)</em></LI>
      <LI>Was glaubt ihr, wie viel Geld eines verkauften Shirts (25 Euro) bei einer Näherin landet?&nbsp;<em>(Lösung: 18 Cent)</em></LI>
      <LI>Was ist Fast Fashion?&nbsp;<em>(Lösung: siehe Definition)</em></LI>
      <LI>Wer bietet Fast Fashion an?&nbsp;<em>(Lösung: u. a.: H&M, Zara, Primark)</em></LI>
    </UL>

    <P gapBefore>
      Zur Auflösung der Fragen können Sie den folgenden Film im Klassenverband zeigen:
    </P>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3_2.js